import React from 'react';
import { cn } from '@shared/lib/utils';
import type { SidebarItem } from '../model/sidebar.types';
import { SidebarMenuItem } from './sidebar-menu-item';

interface SidebarContentProps {
  className?: string;
  items: SidebarItem[];
  onItemClick?: (item: SidebarItem) => void;
  collapsed?: boolean;
}

export function SidebarContent({
  className,
  items,
  onItemClick,
  collapsed,
}: SidebarContentProps): React.ReactElement {
  return (
    <div
      className={cn(
        'flex min-h-0 flex-1 flex-col gap-2',
        'ps-[var(--layout-sidebar-padding-inline-start,32px)] pe-[var(--layout-sidebar-padding-inline-end,24px)]',
        'transition-[padding] duration-normal ease-standard',
        collapsed && 'px-3',
        className
      )}
      data-name="SidebarContent"
    >
      <nav className="flex w-full max-w-[var(--layout-sidebar-menu-width,234px)] flex-col gap-0">
        {items.map((item) => (
          <SidebarMenuItem
            key={item.id}
            item={item}
            onItemClick={onItemClick}
            collapsed={collapsed}
          />
        ))}
      </nav>
    </div>
  );
}
